import { ButtonV2 } from '@labrav/react-components'
import { FooterV2 } from '../../common/components/FooterV2/FooterV2'
import { useStyles } from './ContractsFooterSubmitComponent.styles'

export interface FooterSubmitProps {
  onSubmit: () => void
  onClear: () => void
  submitBtnTitle: string
}

export const ContractsFooterSubmit: React.FC<FooterSubmitProps> = ({
  onSubmit,
  onClear,
  submitBtnTitle,
}) => {
  const { classes } = useStyles()
  return (
    <FooterV2
      width="100%"
      customClass={classes.footerCustomClass}
      actions={
        <div className={classes.footerWrapper}>
          <div className={classes.clearFormButton}>
            <ButtonV2
              data-testid="clear-form-btn"
              styleType="outlined"
              onClick={onClear}
            >
              Clear form
            </ButtonV2>
          </div>
          <ButtonV2
            data-testid="submit-metering-btn"
            styleType="primary"
            onClick={onSubmit}
          >
            {submitBtnTitle}
          </ButtonV2>
        </div>
      }
    />
  )
}
